"use strict";

module.exports = function (name, value, source) {
  this.name = name;
  this.value = value;
  if (source) {
    this.source = source;
  }
};